import actionCreatorFactory from 'typescript-fsa';
import { Dispatch, Action } from 'redux';
import { getAPI, postAPI, delAPI } from '../utils/APIUtils';

import { appActions } from './appAction';
import { InformationState, InformationItem } from '../states/informationState';

const actionCreator = actionCreatorFactory();

export const informationActions = {
    getInformations: actionCreator<InformationState[]>('ACTIONS_GET_INFORMATIONS'),
    getAccounts: actionCreator<InformationState[]>('ACTIONS_GET_ACCOUNTS'),
    getInformationsAsync: (accountId: string, id: string, isInit: boolean = false) => {
        return async (dispatch: Dispatch<Action>) => {
            try {
                const url = `/information?accountid=${accountId}&id=${id}`;
                const json = await getAPI(url);
                dispatch(informationActions.getInformations(json));

                {
                    const url2 = `/account`;
                    const json2 = await getAPI(url2);
                    dispatch(informationActions.getAccounts(json2));
                };

            } catch (err) {
                console.log(err);
            };

            if (!isInit) {
                dispatch(appActions.setLoading(false));
            }
        };
    },
    postInformationAsync: (item: InformationItem) => {
        return async (dispatch: Dispatch<Action>) => {
            try {
                const url = `/information`;
                const options = JSON.parse(JSON.stringify(item));
                await postAPI(url, options);

                // 再取得
                {
                    const url2 = `/information?accountid=${item.accountId}&id=${item.id}`;
                    const json2 = await getAPI(url2);
                    dispatch(informationActions.getInformations(json2));
                };

            } catch (err) {
                console.log(err);
            };
            dispatch(appActions.setLoading(false));
        };
    },
    deleteInformationAsync: (informationId: string, account: string, accountId: string, id: string) => {
        return async (dispatch: Dispatch<Action>) => {
            try {
                const url = `/information?informationId=${informationId}&account=${account}`;
                await delAPI(url);

                // 再取得
                {
                    const url2 = `/information?accountid=${accountId}&id=${id}`;
                    const json2 = await getAPI(url2);
                    dispatch(informationActions.getInformations(json2));
                };
            } catch (err) {
                console.log(err);
            };
            dispatch(appActions.setLoading(false));
        };
    },
};